import { render, staticRenderFns } from "./growthModelFertilizer.vue?vue&type=template&id=9f15e828&scoped=true"
import script from "./growthModelFertilizer.vue?vue&type=script&lang=js"
export * from "./growthModelFertilizer.vue?vue&type=script&lang=js"
import style0 from "./growthModelFertilizer.vue?vue&type=style&index=0&id=9f15e828&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f15e828",
  null
  
)

export default component.exports